/**
 * パスワード表示
 */
class PasswordController{
    constructor() {
    }
    /**
     * 初期化
     */
    init(){
        this.initEvents();
    }
    /* イベント初期化 */
    initEvents(){
        let elms;
        /* パスワードを表示する */
        elms = document.querySelectorAll('[name="showPassword"]');
        elms.forEach((element,i)=>{
            element.addEventListener('change',(e)=>{
                this.onChange(e);
            });
        });
    }
    /**
     * カート更新機能
     * 数量変更時発火
     */
    onChange(e){
        if(e.target.dataset['target']){
            const target = document.querySelector(e.target.dataset['target']);
            if(target){
                target.setAttribute('type',e.target.checked ? 'text':'password');
            }
        }
    }
}
window.addEventListener('DOMContentLoaded',(e) => {
    const pc = new PasswordController();
    pc.init();
});